import { ITraining } from '../../../../../types/interfaces/training';
import { IUser } from '../../../../../types/interfaces/user';
import { getUserViewName } from '../../../../../utils/common/shared-util';

export type TrainingListKind = 'my' | 'fromMe' | 'available';

export type TrainingListSubtitleIcon = 'fromPerson' | 'forPerson' | 'sharedBy';

export interface ITrainingListSubtitle {
  icon: TrainingListSubtitleIcon;
  label: string;
}

/**
 * Subtitle under the training title (primary line + icon) per trainings list tab.
 */
export function getTrainingListSubtitle(
  training: ITraining,
  currentUser: IUser | undefined,
  listKind: TrainingListKind,
): ITrainingListSubtitle | null {
  if (!currentUser?.id) {
    return null;
  }

  if (listKind === 'available') {
    if (!training.owner) {
      return null;
    }
    return {
      icon: 'sharedBy',
      label: getUserViewName(training.owner),
    };
  }

  if (listKind === 'fromMe') {
    if (!training.owner) {
      return null;
    }
    return {
      icon: 'forPerson',
      label: getUserViewName(training.owner),
    };
  }

  const creatorIsAnotherUser =
    !!training.creator?.id && training.creator.id !== currentUser.id;

  if (creatorIsAnotherUser && training.creator) {
    return {
      icon: 'fromPerson',
      label: getUserViewName(training.creator),
    };
  }

  return null;
}
